import * as React from "react"
import { cn } from "@/lib/utils"

export interface SolanaLogoProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  /**
   * Size of the logo in pixels
   * @default 24
   */
  size?: number
}

/**
 * Solana logo component
 *
 * Displays the Solana cryptocurrency logo.
 *
 * @example
 * ```tsx
 * <SolanaLogo />
 * <SolanaLogo size={32} />
 * <SolanaLogo className="opacity-75" />
 * ```
 */
export const SolanaLogo = React.forwardRef<HTMLImageElement, SolanaLogoProps>(
  ({ size = 24, className, style, alt = "Solana", ...props }, ref) => {
    return (
      <img
        ref={ref}
        src="/icons/solana.svg"
        alt={alt}
        className={cn("inline-block", className)}
        style={{
          width: `${size}px`,
          height: `${size}px`,
          ...style
        }}
        {...props}
      />
    )
  }
)

SolanaLogo.displayName = "SolanaLogo"